<template>
  <div class="card-wrapper">
    <div class="card">
      <div class="card-img">
        <div :style="setBackground(content.img)" class="card-bg"></div>
        <div ref="price" class="price" :style="priceStyle">
          <span v-html="content.price"></span>
          <div class="currency">€</div>
          <br />
          <span style="font-size:10px;">{{ content.detail }}</span>
        </div>
        <span v-if="content.age" class="age" v-html="content.age"></span>
      </div>
      <div class="card-content">
        <div class="head">
          <h3 class="card-title title-font">{{ content.title }}</h3>
        </div>
        <div class="info">
          <vue-markdown class="markdown">{{ content.text }}</vue-markdown>
        </div>
        <div class="head">
          <h3 class="card-title title-font">{{ $t("message.booking") }}</h3>
          <div class="resa-link" v-if="!content.lessonIds">
            <custom-btn :link="content.linkSteFoy" customClass="stefoy" :tab="true"
              >Lyon Sainte Foy</custom-btn
            >
            <custom-btn :link="content.linkAlb" customClass="alb" :tab="true"
              >Lyon Albigny</custom-btn
            >
          </div>
          <div v-else>
            <osv-lesson-calendar :lesson-ids="content.lessonIds" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown";
import backgroundFollow from "@/mixins/backgroundFollow.js";
export default {
  mixins: [backgroundFollow],
  components: {
    VueMarkdown
  },
  props: {
    content: null
  },
  methods: {},
  computed: {
    priceStyle() {
      return {
        //height: this.$refs.price.clientWidth + "px",
      };
    }
  },
  mounted() {
    //this.$refs.price.style.height = this.$refs.price.clientWidth + "px";
  }
};
</script>

<style lang="scss">
.card-wrapper {
  padding-bottom: 30px;
  .card {
    width: 700px;
    max-width: 95%;
    margin: auto;
    position: relative;
    background-color: #fff;
    box-shadow: 0px 3px 20px 1px rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    overflow: hidden;
    .card-img {
      position: relative;
      height: 350px;
      width: 100%;
      &:hover {
        .card-bg {
          background-size: 100%;
        }
      }
      .card-bg {
        height: 100%;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 115%;
        clip-path: polygon(0 0, 100% 0%, 100% 75%, 0% 100%);
        transition: background-size 0.4s;
      }
      .age {
        position: absolute;
        top: 0;
        left: 0;
        background: $primary;
        padding: 15px 20px;
        color: #fff;
        z-index: 1;
        font-weight: bold;
        font-size: 18px;
      }
      .price {
        position: absolute;
        z-index: 1;
        top: calc(75% - 40px);
        right: 50px;
        background-color: $primary;
        color: #fff;
        padding: 0 15px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 130px;
        height: 130px;
        span {
          font-size: 28px;
        }
        .currency {
          margin-left: 5px;
          font-size: 18px;
        }
      }
    }

    .card-content {
      position: relative;
      z-index: 1;
      padding: 10px 30px;
      width: 100%;
      .head {
        .card-title {
          text-align: center;
          font-size: 30px;
          color: $primary;
        }
      }
      .info {
        padding: 20px 0;
        white-space: pre-wrap;
        list-style-type: disc;
      }
    }

    .resa-link {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px 0;
      text-align: center;
      a {
        margin: 0 10px;
      }
    }
  }
}
@media screen and (max-width: $desktop) {
  .card-wrapper {
    .card {
      .card-img {
        .price {
          top: calc(75% - 75px);
        }
      }
    }
  }
}
</style>
